import { FC, useEffect, useRef, useState } from 'react';
import { Message } from '../../types/chat';
import { MessageComponent } from './Message';

interface MessageListProps {
  messages: Array<Message & { isLoading?: boolean }>;
  onRegenerate?: (message: Message) => void;
  onCancel?: () => void;
  onSubmitPrompt?: (text: string) => void;
}

export const MessageList: FC<MessageListProps> = ({
  messages,
  onRegenerate,
  onCancel,
  onSubmitPrompt,
}) => {
  const bottomRef = useRef<HTMLDivElement | null>(null);

  const [editingMessageId, setEditingMessageId] = useState<string | number | null>(null);

  useEffect(() => {
    // scroll into view whenever a new message arrives
    bottomRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages.length]);

  return (
    <div className="mx-auto w-full max-w-[860px] flex flex-col gap-4 py-4">
      {messages.map((message, index) => (
        <div key={message.id} className="w-full">
          <MessageComponent
            message={message}
            isLoading={message.isLoading}
            isEditing={String(editingMessageId) === message.id}
            onEditStart={() => setEditingMessageId(message.id)}
            onEditEnd={() => setEditingMessageId(null)}
            onRegenerate={text => onRegenerate?.({ ...message, title: text })}
            onCancel={() => onCancel?.()}
            onSubmitPrompt={onSubmitPrompt}
            isLastMessage={index === messages.length - 1}
          />
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
};
